// React
import React from 'react';
// External
import { withRouter, Link } from 'react-router-dom';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';
import Pagination from 'components/shared/molecules/Pagination/Pagination';
import { getBookings } from 'services/booking';
import newBooking from 'models/Booking';
import ContainerHeader from 'components/shared/molecules/ContainerHeader/ContainerHeader';

// Styles
import './styles.scss';
import EDIT_BOOKING_PATH from 'constants/editBookingPath';
import BookingImage from 'components/shared/atoms/BookingImage/BookingImage';
import imageFallback from 'assets/images/image-not-available.png';

class Bookings extends React.Component {
    constructor(props) {
        super(props);
        const page = new URLSearchParams(window.location.search).get('page');
        this.state = {
            bookingList: [],
            currentPage: page,
            lastPage: null,
            objLightBox: {},
            vet: localStorage.getItem('vet') ? JSON.parse(localStorage.getItem('vet')) : {} 
        };
        this.getBookingList(page);
        this.headers = Object.freeze([
            {
                name: 'Booking ID',
                id: 'orderId',
                className: 'order-id',
            },
            {
                name: 'Pet Tag',
                id: 'img',
                className: 'pet-tag'
            },
            {
                name: 'Service Type',
                id: 'type',
            },
            {
                name: 'Date Created',
                id: 'dateEntered',
                className: 'date-created',
            },
            {
                name: 'Owner Name',
                id: 'ownerName',
            },
            {
                name: 'Pet Name',
                id: 'petName',
            },
            {
                name: 'Status',
                id: 'orderStage',
            },
            {
                name: 'Action',
                id: 'action',
            },
        ]);
        localStorage.removeItem('service-type-name')
    }

    getBookingList() {
        const bookingData = {
            page: this.state.currentPage,
            page_size: 15
        };
        getBookings(bookingData)
            .then((response) => {
                this.setState({ lastPage: response.data.last_page });
                const bookings = response.data.data.map((booking) => {
                    const bookingObj = newBooking(booking);
                    let withCremationPackage = false;
                    // check if booking has a package
                    const productsWithCremationPackage = bookingObj.quotedProducts.find((product) => {
                        if (product.name.toLowerCase().includes('cremation package')) {
                            return product;
                        }
                    });
                    if (productsWithCremationPackage) {
                        withCremationPackage = true;
                    }

                    // get path
                    let editBookingPath = EDIT_BOOKING_PATH.find((editBookingPath) => {
                        // if package
                        if (withCremationPackage || bookingObj.isPackage) {
                            if (editBookingPath.path === "package") {
                                return editBookingPath;
                            }
                        } else if (bookingObj.opportunityType === "referral" &&
                            (bookingObj.serviceType.name === "Private Cremation & Return of Ashes" ||
                             bookingObj.serviceType.name === "Private Cremation & Dispersal of Ashes"
                            )
                        ) { // if private cremation & return of ashes referral
                            if (editBookingPath.path === "referral") {
                                return editBookingPath;
                            }
                        } else if (editBookingPath.serviceType === bookingObj.serviceType.name) {
                            return editBookingPath.path;
                        }
                    });

                    // for vet unity
                    if (editBookingPath?.path && bookingObj?.opportunityType === 'vet_unity') {
                        if (!editBookingPath.path.includes('vetunity') && (!editBookingPath.path.includes('memorabilia'))) {
                            editBookingPath.path = `vetunity-${editBookingPath.path}`;
                        }
                    }

                    let bookingImage = bookingObj.getImage();
                    
                    return {
                        img: <BookingImage bookingImage={bookingImage} onClick={(evt, imageUrl) => {
                            // Only change the lightbox state for non-fallback images
                            if (evt.target.src !== window.location.origin + imageFallback) {
                                this.setState({
                                    objLightBox: {
                                        index: bookingObj.orderId,
                                        url: imageUrl,
                                        onClose: (e) => {
                                            this.setState({ objLightBox: {} }, () => document.body.style.overflow = 'unset');
                                        }
                                    },
                                }, () => document.body.style.overflow = 'hidden');
                            }
                        }} />,
                        ...bookingObj.customTableFormat(),
                        action: (<>
                                { bookingObj.isEditable() && editBookingPath?.path && bookingObj.parsedOrderStage === "Unsubmitted" ?
                                    <Link
                                        to={`/edit-booking-${editBookingPath.path}/${booking.id}`}
                                        onClick={() => localStorage.setItem('service-type-name', bookingObj?.serviceType?.name)}
                                    >Edit</Link> : null
                                }
                                <Link to={`/booking/${booking.id}`}>View</Link>
                            </>)
                    };
                });
                this.setState({ bookingList: bookings });
            }).catch((err) => {
                console.error('err :>> ', err);
            });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title=" View Bookings/Orders" />
                    <ContentCard
                        className="mt-62"
                        divider={false}
                        headerBtnText="View more"
                        headerStyle={{ paddingBottom: 0 }}
                        headerSubComponent={
                            <div className="m-4" />
                        }
                    >
                        <ContainerHeader
                            title="Latest entries"
                        />
                        <CustomTable
                            data={this.state.bookingList}
                            headers={this.headers}
                            className="dashboard-table"
                            disableSort={ true }
                            lightBox={this.state.objLightBox}
                            defaultSortBy={
                                {
                                    id: 'dateEntered',
                                    desc: true,
                                }
                            }
                        />
                        <Pagination className="booking-paginator" lastPage={this.state.lastPage} />
                    </ContentCard>
                </div>
            </div>
        );
    }
}

export default withRouter(Bookings);
